<style scoped>
.table-name {
  font-size: 12px;
  color: var(--color-text-dark);
}
.table-cell {
  height: 60px;
  text-align: right;
}
.asset-panic-table {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
  margin-left: 10px;
  margin-top: 15px;
}
.coin-name {
  font-size: 18px;
  font-weight: normal;
}
.input-sell {
  padding-left: 20px;
  padding-right: 40px;
}
.amount-percent {
  font-size: 12px;
  cursor: pointer;
  padding-left: 10px;
  color:  var(--color-neutral);
}
.error {
  color:var(--color-danger-light);
  text-align: center;
  font-size: 12px;
  height: 10px;
}
td {
  /*border: 1px dotted lightyellow;*/
}
</style>

<template>
  <div>
    <Modal :value="$store.state.assetPanicSellModal.show" width="500" @input="$emit('on-cancel', $event)">
      <table class="asset-panic-table">
        <tr>
          <td class="table-cell">
            <CoinIcon :symbol="asset.Coin" large />
          </td>
          <td class="input-sell">
            <div style="display: flex; align-items: center">
              <div class="coin-name">{{ asset.Coin }}/</div>
              <Select v-model="quoteAsset" size="default" style="width: 30%" @on-change="quoteAssetChanged">
                <Option v-for="asset1 in asset.QuoteAssets" :key="asset1.Asset" :value="asset1.Asset">
                  {{ asset1.Asset }}</Option>
              </Select>
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-name table-cell" style="padding-bottom: 12px">{{ $text.tr('КОЛ-ВО') }}</td>
          <td class="input-sell">
            <i-input v-model="qty" @on-keydown="onkeyDown(qty,$event)" @on-change="qtyChanged">
              <span slot="append"><div style="min-width: 50px;  font-size: 14px;">{{ asset.Coin }}</div></span>
            </i-input>
            <div style="margin-top: 1px">
              <span class="amount-percent" style="padding: 3px" @click="percentFromQty(1)">1%</span>
              <span class="amount-percent" @click="percentFromQty(5)">5%</span>
              <span class="amount-percent" @click="percentFromQty(10)">10%</span>
              <span class="amount-percent" @click="percentFromQty(25)">25%</span>
              <span class="amount-percent" @click="percentFromQty(50)">50%</span>
              <span class="amount-percent" @click="percentFromQty(75)">75%</span>
              <span class="amount-percent" @click="percentFromQty(100)">100%</span>
            </div>
          </td>
        </tr>
        <tr>
          <td class="table-name table-cell">{{ $text.tr('СУММА') }} <span style="font-size: 16px">≈</span></td>
          <td class="input-sell">
            <i-input v-model="amount" @on-keydown="onkeyDown(amount,$event)" @on-change="amountChanged">
              <span slot="append"><div style="min-width: 50px;  font-size: 14px;">{{ quoteAsset }}</div></span>
            </i-input>
          </td>
        </tr>
      </table>
      <div class="error">{{ error }}</div>
      <div slot="footer">
        <div style="display: flex; justify-content: center; align-items: center">
          <Button size="large" long @click="confirm" style="width: 90%" :disabled="qty === '' || qty === '0' || error !== ''"> {{ $text.tr('Продать по рынку').toUpperCase() }} </Button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
// @ts-ignore
import { Asset, Fastbot, QuoteAsset } from '@/util/types'
// @ts-ignore
import Util from '@/util/util'
import Decimal from 'decimal.js'
// @ts-ignore
import Terminal from '@/services/terminal'
import CoinIcon from './CoinIcon.vue'

@Component({
  components: {
    CoinIcon
  }
})

export default class PanicSellModal extends Vue {
  @Prop() private asset!: Asset
  qty: string = ''
  amount: string = ''
  quoteAsset: string = ''
  price: string = ''
  error: string = ''

  @Watch('asset')
  assetChanged () {
    this.qty = this.asset.Free
    if (this.asset.QuoteAssets.length > 0) {
      this.quoteAsset = this.asset.QuoteAssets[0].Asset
      this.price = this.asset.QuoteAssets[0].Price
      this.asset.QuoteAssets.forEach((quoteAsset: QuoteAsset) => {
        switch (quoteAsset.Asset) {
          case 'USDT':
            this.quoteAsset = quoteAsset.Asset
            this.price = quoteAsset.Price
            break
          case 'BTC':
            if (this.quoteAsset !== 'USDT') {
              this.quoteAsset = quoteAsset.Asset
              this.price = quoteAsset.Price
            }
            break
        }
      })
    }
    this.amount = new Decimal(this.qty).mul(this.price).toDP(this.amountDec, Decimal.ROUND_DOWN).toString()
    this.checkQtyError()
  }

  @Watch('$store.state.assetPanicSellModal.show')
  listenKeydown (value: Boolean) {
    if (value) {
      window.addEventListener('keydown', this.confirmOnEnter)
    } else {
      window.removeEventListener('keydown', this.confirmOnEnter)
    }
  }

  get iconpath () {
    if (this.asset.Coin) {
      return 'https://capico.app/icons/color/' + Util.coinIcon(this.asset.Coin.toLowerCase()) + '.png'
    } else {
      return 'https://capico.app/icons/color/def3.png'
    }
  }

  get symbol () {
    return this.asset.Coin + '_' + this.quoteAsset
  }

  get symbolFilter () {
    return this.$store.state.data.symbolsfilter[this.symbol]
  }

  get qtyDec () {
    let qtyDec = 8
    if (this.symbolFilter) {
      qtyDec = parseFloat(this.symbolFilter.QtyDec)
    }
    return qtyDec
  }

  get amountDec () {
    let amountDec = 8
    if (this.symbolFilter) {
      amountDec = parseFloat(this.symbolFilter.PriceDec) + parseFloat(this.symbolFilter.QtyDec)
    }
    return amountDec
  }

  confirmOnEnter (event: any) {
    if (event.keyCode === 13) {
      this.confirm()
    }
  }

  quoteAssetChanged () {
    this.asset.QuoteAssets.forEach((quoteAsset: QuoteAsset) => {
      if (quoteAsset.Asset === this.quoteAsset) {
        this.price = quoteAsset.Price
        this.amount = new Decimal(this.qty).mul(this.price).toDP(this.amountDec, Decimal.ROUND_DOWN).toString()
      }
    })
  }

  onkeyDown (txt: string, e: any) {
    Util.onkeyDown(txt, e)
  }

  amountChanged () {
    if (this.amount === '') {
      return
    }
    this.qty = new Decimal(this.amount).div(this.price).toDP(this.qtyDec, Decimal.ROUND_DOWN).toString()
    this.checkQtyError()
  }

  qtyChanged () {
    if (this.qty === '') {
      return
    }
    this.amount = new Decimal(this.qty).mul(this.price).toDP(this.amountDec, Decimal.ROUND_DOWN).toString()
    this.checkQtyError()
  }

  percentFromQty (percent: number) {
    if (percent === 100) {
      this.qty = this.asset.Free
    } else {
      this.qty = new Decimal(this.asset.Free).div(100).mul(percent).toDP(this.qtyDec, Decimal.ROUND_DOWN).toString()
    }
    this.amount = new Decimal(this.qty).mul(this.price).toDP(this.amountDec, Decimal.ROUND_DOWN).toString()
    this.checkQtyError()
  }

  checkQtyError () {
    this.error = ''
    const qty = new Decimal(this.qty)
    if (qty.greaterThan(this.asset.Free)) {
      // @ts-ignore
      this.error = this.$text.tr('Недостаточно средств')
    }
    if (qty.lessThanOrEqualTo(0)) {
      // @ts-ignore
      this.error = this.$text.tr('Кол-во должно быть больше 0')
    }
    if (this.symbolFilter && qty.lessThan(this.symbolFilter.QtyMin)) {
      // @ts-ignore
      this.error = this.$text.tr('Минимальное кол-во: ') + this.symbolFilter.QtyMin
    }
    if (this.symbolFilter && new Decimal(this.amount).lessThan(this.symbolFilter.AmountMin)) {
      // @ts-ignore
      this.error = this.$text.tr('Минимальная сумма: ') + this.symbolFilter.AmountMin
    }
  }

  confirm () {
    // console.log('confirm', this.asset)
    if (this.qty === '' || new Decimal(this.qty).lessThanOrEqualTo(0)) {
      // @ts-ignore
      this.$Message.warning({
        content: 'invalid qty',
        duration: 5
      })
      return
    }
    Terminal.panicSellAsset(this.symbol, this.qty, this)
    this.$store.state.assetPanicSellModal.show = false
  }
}
</script>
